import React, { useEffect, useState } from "react";
import "../navbar.css";
import { APIURL } from "../config";
import { authFetch } from "../service/apiClient";
import { Row } from "react-bootstrap";
import Snackbar from './Snackbar';
import Loading from './loading';

function Dog1data({ kitData, goBack }) {
    const [, /* years */ setYears] = useState(null); // eslint-disable-line no-unused-vars
    const [, /* surveyData */ setSurveyData] = useState("");
    const [, /* errorMessage */ setErrorMessage] = useState('');
    const [filteredData, setFilterd] = useState('');
    const [, /* reportData */ setReportData] = useState('');
    const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "info" });
    const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));
    const [loading, setLoading] = useState(false);

    // eslint-disable-next-line no-unused-vars
    const classifications = [
        { name: "cortisolClassification", value: "Cortisol Insights" },
        { name: "DHAClassification", value: "DHA Insights" },
        { name: "VitaminDClassification", value: "Vitamin D Insights" },
        { name: "alphatocopherolClassification", value: "Alpha Tocopherol Insights" },
        { name: "DPAClassification", value: "DPA Insights" },
        { name: "riboflavinClassification", value: "Riboflavin Insights" },
        { name: "EPAClassification", value: "EPA" },
        { name: "OAClassification", value: "Osteo Arthritis" },
        { name: "SerumTASClassification", value: "Total Anti Oxidant Status" }

    ];

    useEffect(() => {
        setSurveyData(kitData);
        setLoading(true);
        const apiUrl = APIURL + `/getBlastOffRuleResultByKitID?kit_id=${kitData.kit_id}`;
        authFetch(apiUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok. Status: ' + response.status);
                }
                return response.json();
            })
            .then(data => {
                setErrorMessage(null);
                if (data.message === 'success') {
                    setFilterd(data.ItemInfo);
                }
            })
            .catch(error => {
                setErrorMessage(error.message);
                setFilterd(null);
                setSnackbar({ open: true, message: "Failed to load report data. Please try again.", type: "error" });
            })
            .finally(() => setLoading(false));


    }, [kitData])

    // eslint-disable-next-line no-unused-vars
    const handleReportData = (filterValue) => {

        let data = filteredData.filter(item => item.variable1_name === filterValue);
        const order = ["Description", "Results", "Recommendations"];
        data = data.sort((a, b) => {
            return order.indexOf(a.sub_section_id) - order.indexOf(b.sub_section_id);
        });
        setReportData(data);
    }

    return (
        <>
            {loading && <Loading message="Loading report data..." />}
            <Snackbar message={snackbar.message} type={snackbar.type} open={snackbar.open} onClose={closeSnackbar} />
             <Row className="justify-content-center" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '600px' }}>
                <div className="heading" style={{
                    position: 'absolute',
                    padding: '20px',
                    borderRadius: '10px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    top: '20%',
                    left: '51%',
                    transform: 'translate(-50%, -50%)'
                }}>
                    Coming Soon...
                </div>
            </Row>

            {/* <div className="reportContent">
                <div className="heading">
                Polygenetic nutritional report
                </div>
                <div className="contentReport">
                    {errorMessage ? (
                        <div style={{ marginRight: "20px" }}>
                            <br></br>
                            <Alert variant="danger" style={{ textAlign: "center" }}>Report generation is in progress.</Alert>
                        </div>
                    ) : (
                        <>
                            <Row>
                                {classifications.map((item, index) => (
                                    <Col sm={2}>
                                        <Button className='reportButtonTest' onClick={() => handleReportData(item.name)}>{item.value}</Button>
                                    </Col>
                                ))}
                            </Row>
                            {reportData && (
                                <>
                                    {reportData.map((data, index) => (
                                        <>
                                            <br></br>
                                            <div style={{ border: "2px solid rgb(13 121 120)", padding: "10px", width: "80vw" }}>
                                                <div className="reportHeading">
                                                    {data.sub_section_id}
                                                </div>
                                                <span>
                                                    {data.result1_value}
                                                </span>
                                            </div>
                                            <br></br>
                                        </>
                                    ))}
                                </>
                            )}
                        </>
                    )}

                </div>
            </div> */}
        </>
    )
}
export default Dog1data;